import { z } from 'zod'

import { StructuredDataSchemaItem } from '../../dtos/structured-data'
import baseSchemaFields from './base-schema'
import { makeTypeLiteral } from './helpers'

export default z.object({
  ...baseSchemaFields,
  type: makeTypeLiteral('enum'),
  enumValues: z
    .array(z.string().trim().min(1, 'Enum value cannot be empty'))
    .min(2, 'At least 2 enum values are required')
    .refine(
      (arr) => {
        const lower = arr.map((v) => v.toLowerCase())
        return lower.length === new Set(lower).size
      },
      { message: 'Enum values must be unique' },
    ),
  defaultValue: z.string().nullable(),
})

export const validateEnumSchema = {
  fn: (data: StructuredDataSchemaItem) => {
    if (data.type === 'enum' && data.defaultValue) {
      return data.enumValues.includes(data.defaultValue)
    }
    return true
  },
  error: {
    message: 'Default value must be one of the enum values',
    path: ['defaultValue'],
  },
}
